/* eslint-disable */

// JavaScript Document
/**
 *	リマインダー画面を開く
 */

function openReminderWindow(url){
  window.open(url, 'mywindow1', 'width=600, height=400, menubar=no, toolbar=no, scrollbars=yes');
}

window.openReminderWindow = openReminderWindow;


// WEBPACK FOOTER //
// ./es6/admin-pages-js/etc/reminder.js